import styled from 'styled-components'

const Base = styled.span`
    font-size:${props => props.fontSize ? `${props.fontSize};` : '1rem'};
    color:${props => props.color ? `${props.color};` : 'inherit'};
    margin: ${props => props.margin ? `${props.margin};` : '0.7rem 0'};
    ${props => props.textAlign && `text-align: ${props.textAlign};`}
    ${props => props.fontWeight && `font-weight: ${props.fontWeight};`}
    ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
    ${props => props.minWidth && `min-width: ${props.minWidth};`}
    ${props => props.width && `width: ${props.width};`}
    ${props => props.bold && `font-weight: 900;`}`

export default Base